import { Component, Input } from '@angular/core';
import { Estimate } from '../../models/estimate.model';
import { Invoice } from '../../models/invoice.model';
import { ClientItemsResult, ClientsService } from "../../services/clients.service";
import { Job } from "../../models/jobs.model";
import { Assessment } from "../../models/assessment.model";
import { Router } from '@angular/router';
import { ScheduleService } from '../../services/schedule.service';
import { Lead } from 'projects/common/src/lib/models/lead.model';

@Component({
  selector: 'app-customer-tile',
  templateUrl: './customer-tile.component.html',
  styleUrls: ['./customer-tile.component.scss']
})
export class CustomerTileComponent {

  @Input() item!: ClientItemsResult<Assessment | Job | Estimate | Invoice | Lead>;
  @Input() showUser = false;

  constructor(
    private router: Router,
    private clientsService: ClientsService,
    private scheduleService: ScheduleService,
  ) { }

  get users() {
    if (this.item.itemType === 'job')
      return this.item.assigneeCount && this.item.assigneeCount > 1 ? `${this.item.assigneeCount} assignees` : `${this.item.assigneeInfo[0].firstName} ${this.item.assigneeInfo[0].lastName[0]}.`;

    return this.item.ownerFirstName + ' ' + this.item.ownerLastName[0] + '.';
  }

  get assigneeNames() {
    return this.item.assigneeInfo.map(assignee => `${assignee.firstName} ${assignee.lastName[0]}.`).join('\n');
  }

  onClick() {
    this.clientsService.saveClientsList();
    if (this.item.itemType === 'lead')
      this.scheduleService.openLead(this.item.id);
    else
      this.router.navigate([`/${this.item.itemType}s`, this.item.workflowId, this.item.id]);
  }

}
